import { BackendUriUnits } from "./base/backend-uri-units";
import { BaseHttpWithBundleService } from "./base/base-service-with-bundle.service";
import { map } from "rxjs/operators";
import { Inject, Injectable } from "@angular/core";
import { HttpServiceBundle } from "./base/http-service-bundle.service";
import { APP_CONFIG, AppConfig } from "@app/app-config.module";
import { BaseList } from "@app/shared/models/list";
import { Inbox } from "@app/shared/models/inbox";
import { DRResponse, ResponseColumn } from "@app/shared/models/response";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class InboxService extends BaseHttpWithBundleService {
  private readonly baseUrl = `${this.uri}/${BackendUriUnits.DISPATCHER}`;

  constructor(
    httpServiceBundle: HttpServiceBundle,
    @Inject(APP_CONFIG) protected appConfig: AppConfig
  ) {
    super(httpServiceBundle, true);
  }

  public getInboxOverviewData(): Observable<BaseList<Inbox>> {
    const url = `${this.baseUrl}/inbox`;

    let params = {
      columns: this.getInboxTableColumns().map(column => column.id).join(',')
    };

    return this.http
      .get<DRResponse<{ inboxEntries: Inbox[] }>>(url, { params })
      .pipe(map((res) => new BaseList(Inbox, res.data.inboxEntries)));
  }

  public importCaseFromInboxEntry(inbox: Inbox): Observable<any> {
    const url = `${this.baseUrl}/inbox/${inbox.id}/case`;
    return this.http
        .post<DRResponse<any>>(url, { id: inbox.id })
        ;
  }

  public rejectCaseFromInboxEntry(inbox: Inbox, commentText: string = ''): Observable<any> {
    const url = `${this.baseUrl}/inbox/${inbox.id}/reject`;
    return this.http
        .post<DRResponse<any>>(url, { comment: commentText })
        .pipe(map(res => res.data));
  }

  public deleteInboxEntries(entries: Inbox[]): Observable<any> {
    const url = `${this.baseUrl}/inbox`;
    const operations = entries.map(entry => ({ op: 'remove', from: entry.id }));
    return this.http.patch<DRResponse<any>>(url, operations);
  }

  public getInboxTableColumns(): Array<ResponseColumn> {
    return this.appConfig.defaults.dashboard.widgets.inboxOverview.settings.columns;
  }
}
